import { createFileRoute } from '@tanstack/react-router'
import { SectionHeader, useSiteScope } from '../../-section'
import { ProspectTable } from '../-parts'

export const Route = createFileRoute('/_app/$org/$host/outreach/_list/dismissed')({
  component: DismissedPage,
})

/** What was turned down and by whom, newest first, so a judge that is wrong
 * about a kind of page is caught while its reasons are still on screen. */
function DismissedPage() {
  const { org, host, site } = useSiteScope()
  return (
    <>
      <SectionHeader title="Dismissed" />
      <ProspectTable
        site={site}
        org={org}
        host={host}
        view="dismissed"
        empty={{
          title: 'Nothing dismissed',
          description: `Nothing has been turned down for ${host}.`,
        }}
      />
    </>
  )
}
